module.exports = __webpack_public_path__ + "static/media/iconInsta2.81291697.png";